<div class="modal" tabindex="-1" role="dialog" [ngClass]="isModalOpen() ? 'open-modal' : 'close-modal'">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content alert-modal">
      <div class="title-body">
        <div>
          <span class="modal-title title"> {{(title() | translate) ? (title() | translate): title()}}</span>
        </div>
        <div class="modal-body">
          @if (showCheckBox) {
          <div id="input-checkbox">
            <input type="checkbox" value="true" name="checkbox" [(ngModel)]="isChecked">
          </div>
          }
          <div class="body"
            [innerHtml]="message() | translate | placeholderReplace: {placeholderObject: translationData}">
          </div>
        </div>


      </div>
      <div class="line-seperator">
      </div>
      <div class="footer-container">
        <div class="button-region">
          <button type="button" class="hallow" data-dismiss="modal" (click)="onCancel()"
            [hidden]="hideSecondaryBtn() === 'hide'"><span>{{(cancelBtnTitle() | translate) ? (cancelBtnTitle() |
              translate): cancelBtnTitle()}}</span></button>
          <button type="button" class="beta" data-dismiss="modal" (click)="onAction()"><span>{{(actionBtnTitle()
              | translate) ? (actionBtnTitle() | translate): actionBtnTitle()}}</span></button>
        </div>
      </div>
    </div>
  </div>
</div>